import React from 'react';
import './About.css';
import Main from './main.js';
import Features from './features.js';
import Contact from './contact.js';
import Me from './Me.js';
const About = () => {
  return (
    <div className="about-page">
      
      <h1>About</h1>
      <Main/>
      <hr/>
      <br/>
      <Features/>
      <hr/>
      <br/>
      <Me/>
      <hr/>
      <br/>
      <Contact/>

    </div>
  );
};

export default About;

